import moment from 'moment-timezone-all'

export const START_OF_REPORTS = moment('2017-12-01T00:00:00')

// OpenSearch-only accounts can't report further back than this.
export const OPENSEARCH_ONLY_MAX_LOOKBACK_DAYS = 30

// First day of live inbox data in OpenSearch. OpenSearch-only queries never
// start earlier, so other data lines up with resolutions (which predate it).
export const OPENSEARCH_ONLY_DATA_START = '2026-09-14'
